
import "../Foundation/stylable/spacing.st.css.js";
import "../BaseModalLayout/BaseModalLayout.st.css.js";
import "../Heading/Heading.st.css.js";
import "../Text/Text.st.css.js";
import "../Foundation/stylable/typography.st.css.js";
import "../Foundation/stylable/border.st.css.js";

import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_220_2_AnnouncementModalLayout";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_220_2_AnnouncementModalLayout__root","announcementModalLayout":"wds_1_220_2_AnnouncementModalLayout__announcementModalLayout","link":"wds_1_220_2_AnnouncementModalLayout__link","bottomSpacing":"wds_1_220_2_AnnouncementModalLayout__bottomSpacing"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wsr-heading-font-size-m":"--wsr-heading-font-size-m","wsr-heading-font-size-xl":"--wsr-heading-font-size-xl","wsr-text-line-height-medium":"--wsr-text-line-height-medium","wds-announcement-modal-actions-padding":"--wds-announcement-modal-actions-padding","wds-announcement-modal-border-radius":"--wds-announcement-modal-border-radius","wds-announcement-modal-content-gap":"--wds-announcement-modal-content-gap","wds-announcement-modal-padding-horizontal":"--wds-announcement-modal-padding-horizontal","wds-announcement-modal-padding-vertical":"--wds-announcement-modal-padding-vertical","wds-announcement-modal-text-font-line-height":"--wds-announcement-modal-text-font-line-height","wds-announcement-modal-text-font-size":"--wds-announcement-modal-text-font-size","wds-announcement-modal-title-font-line-height":"--wds-announcement-modal-title-font-line-height","wds-announcement-modal-title-font-size":"--wds-announcement-modal-title-font-size","wds-space-200":"--wds-space-200","wds-space-500":"--wds-space-500","wds-space-700":"--wds-space-700","wds-space-800":"--wds-space-800","wds-space-1300":"--wds-space-1300"}; 




